import { render } from "./preApproved.vue?vue&type=template&id=3ebef7c6&ts=true"
import script from "./preApproved.vue?vue&type=script&lang=ts"
export * from "./preApproved.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__